// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { xBaseTheme } from "@guestsupply/XDL/types";
import { css } from "styled-components";

export default {
    fontFamilyImportUrl: "/staticContent/stylesheet.css",
    body: {
        size: "16px",
        weight: "normal",
        fontFamily: "'Gotham', 'Roboto', 'Lato', sans-serif",
        color: "text",
    },
    p: {
        size: "16px",
        weight: "normal",
        color: "text",
        css: css`
            margin-bottom: 1rem;
            display: block;
        `,
    },
    h1: {
        size: "32px",
        weight: 700,
        color: "text",
        css: css`
            margin-bottom: 20px;
            display: block;
            line-height: 40px;
        `,
    },
    h2: {
        size: "28px",
        weight: 700,
        color: "text",
        css: css`
            margin-bottom: 1rem;
            display: block;
            line-height: 34px;
        `,
    },
    h3: {
        size: "24px",
        weight: 700,
        color: "text",
        css: css`
            margin-bottom: 1rem;
            display: block;
            line-height: 30px;
        `,
    },
    h4: {
        size: "20px",
        weight: 700,
        color: "text",
        css: css`
            margin-bottom: 1rem;
            display: block;
            line-height: 26px;
        `,
    },
    h5: {
        size: "18px",
        weight: 700,
        color: "text",
        css: css`
            margin-bottom: 1rem;
            display: block;
            line-height: 22px;
        `,
    },
    h6: {
        size: "16px",
        weight: 700,
        color: "text",
        css: css`
            margin-bottom: 1rem;
            display: block;
            line-height: 19px;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "24px",
        fontFamily: "'Gotham', 'Roboto', 'Lato', sans-serif",
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: "'Gotham', 'Roboto', 'Lato', sans-serif",
        transform: "uppercase",
        weight: 800,
        color: "text",
    },
    headerTertiary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: "'Gotham', 'Roboto', 'Lato', sans-serif",
        color: "text.main",
        transform: "uppercase",
    },
    legend: {
        forwardAs: "span",
        size: "10px",
        color: "text.accent",
        transform: "uppercase",
        weight: 600,
    },
} as xBaseTheme["typography"];
